import { makeRequest } from 'utils/requestLogger';

export default (duplicate_RT_id, courses, isToCopy = true) =>
  makeRequest(
    'post',
    `/api/roundtables/${duplicate_RT_id}/duplicate`,
    { courses, isToCopy}
  ).then((res) => res.data);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/duplicateRT.js